import MenuNavigator from "../../components/menu-navigator";
import "./styles.css";

const Indicadores = ({
	token = JSON.parse(sessionStorage.getItem("token")),
}) => {
	const handleViewComponent = () => {
		return (
			<iframe
				className="iframe-dashboard dashboard"
				title="dash-bi"
        // style={{height: "95%"}}
				//exemplo de dash
				src="https://app.powerbi.com/view?r=eyJrIjoiYWNkMWEyMjctM2NhMS00YjUyLWJkODgtYWY2Yzk2NzNiODk5IiwidCI6ImJhMzg5NTgyLTA0M2ItNDBhYS04ZWJlLWNmYjBhZTI4MjgzMyJ9"
			></iframe>
		);
	};

	return (
		<MenuNavigator
			token={token}
			page="/home"
			view={handleViewComponent()}
		></MenuNavigator>
	);
};

export default Indicadores;
